export default function FundingProgress({ percent = 0 }) {
  const numeric = Number(percent);
  const safe = Number.isFinite(numeric) ? Math.min(100, Math.max(0, numeric)) : 0;
  return (
    <div>
      <div className="d-flex justify-content-between small text-muted mb-1">
        <span>Funding progress</span>
        <span>{safe}%</span>
      </div>
      <div className="progress rounded-pill" style={{ height: 8 }}>
        <div
          className="progress-bar rounded-pill"
          style={{ width: `${safe}%`, background: "var(--color-secondary)" }}
        />
      </div>
    </div>
  );
}
